import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import MasterListCommonTable from "./masterlistcommontable";
import { DataRow, DropdownModel } from "../../../data/interfaces/sharedmodels";


export default function MasterListDialog({isopen,listType,excludedCodes,callback}:
    {isopen:boolean,listType:DropdownModel,excludedCodes:string[], callback:any}){
    const [open,setOpen]=useState<boolean>(isopen);
    const [selectedCodes,setSelectedCodes]=useState<DropdownModel[]>([]);
    useEffect(()=>{
        setOpen(isopen);
    },[isopen]);
    const handleClose=()=>{
        
        callback([]);
    }
    const handleOk=()=>{
        callback(selectedCodes);
        
    }

    const selectedCallback=(selected:boolean, row:DataRow)=>{
        let tempItems=[...selectedCodes];
        if( selectedCodes.findIndex(a=>a.Id==row.UniqueIdValue)<0){
            
            tempItems.push({Id:row.UniqueIdValue,Description:row.UniqueIdValue})
        }
        else{
            if(selected==false){
                tempItems= tempItems.splice(tempItems.findIndex(a=>a.Id==row.UniqueIdValue),1);
            }
        }
        setSelectedCodes(tempItems);
    }
    return(
        <Dialog open={open} onClose={handleClose} onSubmit={handleOk}>
            <DialogContent>
                <MasterListCommonTable listType={listType} excludedCodes={excludedCodes} asLookup={true} callback={selectedCallback}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleOk}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}